import React, { useState } from "react";
import { Spin, Alert as AlertAntd, Typography } from "antd";
import AlertDialog from "./AlertDialog";
import { JoinedAlert } from "../../../types";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon } from "@heroicons/react/24/solid";

import "./index.css";

const { Title, Text } = Typography;

type Props = {
  loading: boolean;
  listContainerRef: React.RefObject<HTMLDivElement>;
  joinedAlerts: JoinedAlert[];
};

const MaintenanceAlert: React.FC<Props> = ({
  loading,
  listContainerRef,
  joinedAlerts,
}) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="detection-box-container">
      <Spin spinning={loading}>
        <div
          className="detection-box-title"
          onClick={() => setExpanded((prev) => !prev)}
          style={{ cursor: "pointer" }}
        >
          <Title level={4} className="detection-box-title-text">
            Trap maintenance
          </Title>
          {expanded ? (
            <ChevronUpIcon className="w-5 h-5 text-[#003A55]" />
          ) : (
            <ChevronDownIcon className="w-5 h-5 text-[#003A55]" />
          )}
        </div>
        {expanded ? (
          <div
            ref={listContainerRef}
            className={`detection-box-alerts ${
              joinedAlerts.length > 0 ? "has-alerts" : "no-alerts"
            }`}
          >
            {joinedAlerts.length > 0 ? (
              joinedAlerts.map((item: JoinedAlert) => (
                <AlertDialog key={item._id} item={item} />
              ))
            ) : (
              <AlertAntd
                message={<Text strong>No maintenance alerts</Text>}
                showIcon
                type="success"
                icon={<CheckCircleIcon className="w-6 h-6 text-[#22C55E]" />}
              />
            )}
          </div>
        ) : (
          <div className="alert-dialog-container">
            <AlertAntd
              message={
                <Text className="font-bold">
                  {joinedAlerts.length} Maintenance alert
                  {joinedAlerts.length !== 1 ? "s" : ""}
                </Text>
              }
              showIcon
              icon={
                <ExclamationTriangleIcon className="w-6 h-6 text-[#F97316]" />
              }
              type="warning"
            />
          </div>
        )}
      </Spin>
    </div>
  );
};

export { MaintenanceAlert };
